import { useState } from "react";
import { Share2, Copy, Check, Gift } from "lucide-react";
import { motion } from "framer-motion";

const Referral = () => {
  const [copied, setCopied] = useState(false);
  const referralCode = "DASH2026XYZ";
  const referralLink = `https://dashboard.dkonnects.com/ref/${referralCode}`;

  const handleCopy = () => {
    navigator.clipboard.writeText(referralLink);
    setCopied(true);
    setTimeout(() => setCopied(false), 2000);
  };

  return (
    <div className="py-10 md:py-14">
      <div className="container mx-auto px-4 max-w-2xl">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          className="text-center mb-10"
        >
          <div className="w-16 h-16 rounded-full bg-accent/10 flex items-center justify-center mx-auto mb-4">
            <Gift size={32} className="text-accent" />
          </div>
          <h1 className="section-title mb-3">Refer & Earn</h1>
          <p className="text-muted-foreground max-w-md mx-auto">
            Share Dashboard with your friends and earn rewards. Register to get your unique referral link.
          </p>
        </motion.div>

        <div className="finance-card p-6 mb-6">
          <h3 className="font-display font-semibold mb-4">Your Referral Link</h3>
          <div className="flex items-center gap-2">
            <div className="flex-1 bg-muted rounded-lg px-4 py-3 text-sm text-foreground font-mono truncate">
              {referralLink}
            </div>
            <button
              onClick={handleCopy}
              className="shrink-0 p-3 rounded-lg bg-primary text-primary-foreground hover:opacity-90 transition-opacity"
            >
              {copied ? <Check size={18} /> : <Copy size={18} />}
            </button>
          </div>
          <p className="text-xs text-muted-foreground mt-3">
            Your referral code: <strong>{referralCode}</strong>
          </p>
        </div>

        <div className="finance-card p-6">
          <h3 className="font-display font-semibold mb-4 flex items-center gap-2">
            <Share2 size={18} className="text-secondary" /> How it works
          </h3>
          <ol className="space-y-3 text-sm text-muted-foreground">
            <li className="flex gap-3">
              <span className="w-6 h-6 rounded-full bg-secondary text-secondary-foreground flex items-center justify-center text-xs font-bold shrink-0">1</span>
              Share your unique referral link with friends & family
            </li>
            <li className="flex gap-3">
              <span className="w-6 h-6 rounded-full bg-secondary text-secondary-foreground flex items-center justify-center text-xs font-bold shrink-0">2</span>
              They sign up using your link and explore Dashboard
            </li>
            <li className="flex gap-3">
              <span className="w-6 h-6 rounded-full bg-secondary text-secondary-foreground flex items-center justify-center text-xs font-bold shrink-0">3</span>
              You earn rewards as defined by our referral program
            </li>
          </ol>
        </div>

        <p className="text-xs text-muted-foreground text-center mt-6">
          Register or log in to track your referrals and earnings. Referral program terms are managed by admin.
        </p>
      </div>
    </div>
  );
};

export default Referral;
